export const LOADING = '/loading';
export const LOGIN = '/login';
export const FORGOT_PASSWORD_EMAIL = '/forgot_password/email_confirm';
export const FORGOT_PASSWORD_RESET = '/forgot_password/reset';
export const REGISTER_CREDENTIALS = '/register/credentials';
export const REGISTER_EMAIL_CONFIRM = '/register/email_confirm';
export const REGISTER_CREATE_PROFILE = '/register/create_profile';
export const PLATFORM_HOME = '/';
export const FIND_YOUR_CADDIE = '/postround/find'
export const PAY_CADDIE = '/postround/pay'
export const PAYMENT_CONFIRMATION = '/postround/pay/confirmation'
export const REVIEW_CADDIE = '/postround/review'
export const REVIEW_CONFIRMED = '/postround/confirmation'

export const buildUrl = (url: string): string => {
    return "/platform" + url
}